import React, { useEffect, useState } from 'react';
import Overlay from '../../../Overlay/Overlay';
import './unsubscribe.scss';
import { Loader } from 'cdk-radial';
import { unsubscribeLocations, fetchSolutionConnections, disableConnection } from '../../../../redux/connectedComponent/removeLocations/removeLocations.slice';

const CUSTOM_STYLE = {
    width: "660px"
};
const COLOR_STROKE = 'rgba(21,27,37,0.4)';
const UNSUBSCRIBING = 'Unsubscribing...';
const DEACTIVATING = 'Deactivating...'
const UNSUBSCRIBE = 'Unsubscribe';
const DEACTIVATE = 'Deactivate'
const CANCEL = 'Cancel';

function Unsubscribe({
    useDispatch, 
    useSelector, 
    solutionData = {overview: {}}, 
    active,
    title,
    onUnsubscribeOverlayClose,
    appName,
    activeSubscriptionsData,
    isBulkSubscribed,
    subscriptionData,
    ...props
    }) {
       const id = solutionData.id;
       const name = solutionData?.overview?.name || solutionData?.displayName

    const dispatch = useDispatch();
    const state = useSelector(state => state);

    const [showDialogSpinner, setShowDialogSpinner] = useState(false);
    const token = state && state.loginDetailsSlice && state.loginDetailsSlice.authenticationToken;
    const userEmail = state && state.loginDetailsSlice && state.loginDetailsSlice.userEmail;
    const connectionIdsToBeDisabled = state && state.removeLocationsSlice && state.removeLocationsSlice.connectionIdsToBeDisabled;
    const fetchSolutionConnectionsPending = state && state.removeLocationsSlice && state.removeLocationsSlice.fetchSolutionConnectionsPending;
    const isDisableSolutionConnectionPending = state && state.removeLocationsSlice && state.removeLocationsSlice.isDisableSolutionConnectionPending;
    const isUnsubscribeLocationsPending = state && state.removeLocationsSlice && state.removeLocationsSlice.isUnsubscribeLocationsPending;
    const fetchSolutionConnectionsFulfilled = state && state.removeLocationsSlice && state.removeLocationsSlice.fetchSolutionConnectionsFulfilled;
    const isDisableSolutionConnectionFulfilled = state && state.removeLocationsSlice && state.removeLocationsSlice.isDisableSolutionConnectionFulfilled;
    const isUnsubscribeLocationsFulfilled = state && state.removeLocationsSlice && state.removeLocationsSlice.isUnsubscribeLocationsFulfilled;
    const allLocations = state && state.loginDetailsSlice && state.loginDetailsSlice.allLocations;
    const firstName = state?.loginDetailsSlice?.decodedToken?.firstName;
    const lastName = state?.loginDetailsSlice?.decodedToken?.lastName;

    useEffect(() => {
        if (connectionIdsToBeDisabled && connectionIdsToBeDisabled.length) {
            dispatch(disableConnection({ connectionIds: connectionIdsToBeDisabled, token }))
        }
    }, [connectionIdsToBeDisabled])

    useEffect(() => {
        let appName = name;
        let isSubscription = solutionData.activateOnly===false
        let unsubscribedLocations = []
        subscriptionData && subscriptionData.map(item => {
            unsubscribedLocations.push({
                partyName: item && item.entityIdList && item.entityIdList[0] && item.entityIdList[0].location,
                entityId: item && item.entityIdList && item.entityIdList[0] && item.entityIdList[0].entityId,
                cmfNumber: item && item.entityIdList && item.entityIdList[0] && item.entityIdList[0].cmfNumber
            });
        });
        if (isBulkSubscribed && isUnsubscribeLocationsFulfilled ){
            props.onUnsubscribeOverlayAccept(appName, false,isSubscription);
        }
        if (!isUnsubscribeLocationsPending && !fetchSolutionConnectionsPending && connectionIdsToBeDisabled && connectionIdsToBeDisabled.length === 0) {
            if (isUnsubscribeLocationsFulfilled && fetchSolutionConnectionsFulfilled) {
                props.onUnsubscribeOverlayAccept(appName, false,isSubscription);
            }
            else {
                props.onUnsubscribeOverlayAccept(appName, true,isSubscription);
            }
        } else if (!isUnsubscribeLocationsPending && !fetchSolutionConnectionsPending && !isDisableSolutionConnectionPending && connectionIdsToBeDisabled && connectionIdsToBeDisabled.length !== 0) {
            if (isUnsubscribeLocationsFulfilled && fetchSolutionConnectionsFulfilled && isDisableSolutionConnectionFulfilled) {
                props.onUnsubscribeOverlayAccept(appName, false,isSubscription);
            }
            else {
                props.onUnsubscribeOverlayAccept(appName, true,isSubscription);
            }
        }
    }, [fetchSolutionConnectionsPending, isDisableSolutionConnectionPending, isUnsubscribeLocationsPending]);

    const onUnsubscribeOverlayAccept = () => {
        setShowDialogSpinner(true);
        let solutionId = id;
        let entityIds = subscriptionData && subscriptionData.map(subscription => subscription.entityId);
        let subscriptions = [];
        subscriptionData.forEach(subscription =>{
           let location = allLocations.filter(loc => loc.entityId === subscription.entityId)
           subscriptions.push({
             subscriptionId: subscription.subscriptionId,
             orgName: location[0].orgName,
             entitycmfNumber: subscription.entitycmfNumber,
             entityId: subscription.entityId,
           });
        });

        dispatch(unsubscribeLocations({ solutionId, entityIdList: entityIds, token,isBulkSubscribed,buyerName:`${firstName} ${lastName}`, buyerEmail:userEmail, subscriptions, solutionData }))
        if (!isBulkSubscribed) {
          dispatch(
            fetchSolutionConnections({ solutionId, entities: entityIds, token })
          );
        }
    }

    useEffect(() => {
        if(isUnsubscribeLocationsFulfilled) {
             let solutionId = id;
            let entityIds = subscriptionData && subscriptionData.map(subscription => subscription.entityId);

            let entityIdsWithSolutionId = entityIds && entityIds.length && entityIds.map(entityId => {
                return {
                    entityId: entityId,
                    solutionId: solutionId
                }
            });
        }
    }, [isUnsubscribeLocationsFulfilled])

    return (
        <Overlay
            active={active}
            title={title}
            onOverlayClose={onUnsubscribeOverlayClose}
            onOverlayAccept={() => onUnsubscribeOverlayAccept()}
            firstButtonText={CANCEL}
            secondButtonText={showDialogSpinner ? <Loader label={solutionData.activateOnly === false ? UNSUBSCRIBING : DEACTIVATING} style={{stroke: COLOR_STROKE}}/> : (solutionData.activateOnly === false ? UNSUBSCRIBE : DEACTIVATE)}
            customeStyle={CUSTOM_STYLE}
            disableFirstButton={showDialogSpinner}
            disableSecondButton={showDialogSpinner}
            hideFirstButton={showDialogSpinner}
        >
            <div className={'unsubscribe-overlay-body'}>All locations will lose access to {appName} when you {solutionData.activateOnly === false ? 'unsubscribe' : 'deactivate'}. Contact the app provider with
            any questions on how this affects your billing.</div>
        </Overlay>
    )
}

function areEqual(prevProps, nextProps) {
    /*
    return true if passing nextProps to render would return
    the same result as passing prevProps to render,
    otherwise return false
    */
   return prevProps.active === nextProps.active ? true : false;
}

export default React.memo(Unsubscribe, areEqual);